// src/components/ProgressTracker.tsx
import { motion } from 'framer-motion'

interface ProgressTrackerProps {
  total: number
  found: number
  currentIndex: number
}

export function ProgressTracker({ total, found, currentIndex }: ProgressTrackerProps) {
  return (
    <div className="flex items-center gap-1.5 py-1 flex-wrap">
      {Array.from({ length: total }).map((_, i) => {
        const isFound = i < found
        const isCurrent = i === currentIndex

        return (
          <motion.div
            key={i}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: i * 0.05, type: 'spring', stiffness: 500 }}
            className="relative flex items-center justify-center"
          >
            <motion.div
              animate={{
                backgroundColor: isFound ? '#A8E6CF' : isCurrent ? '#FFE66D' : '#E2E8F0',
                scale: isCurrent ? 1.15 : 1,
              }}
              transition={{ type: 'spring', stiffness: 400 }}
              className="w-12 h-12 rounded-full flex items-center justify-center text-xl shadow-sm"
            >
              {isFound ? '✅' : '🥚'}
            </motion.div>
          </motion.div>
        )
      })}
    </div>
  )
}
